"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultValue = exports["default"] = exports.Address = void 0;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations.validations;
  }
});
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.function.name.js");
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formElements = require("@evidation/form-elements");
var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));
var _services = require("../../services");
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _logger = require("@evidation/logger");
var _components = require("./components");
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../../contexts/LanguageContext");
var _validations = require("./validations");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var defaultValue = exports.defaultValue = {
  value: ''
};
var Address = exports.Address = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Address, _React$Component);
  var _super = _createSuper(Address);
  function Address(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Address);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (event, _ref) {
      var newValue = _ref.newValue,
        method = _ref.method;
      if (newValue.trim().length !== 0 && !_lodash["default"].includes(['down', 'up'], method)) _this.setState({
        loading: true
      });
      // If the value is blank, we should not construct an object here so that the
      //   key is omitted entirely. The backend expects either no value for the
      //   key or a valid object.
      var value = newValue ? {
        value: newValue
      } : undefined;
      _this.props.input.onChange(value);
      _this.setState({
        value: value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSuggestionsFetchRequested", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref2) {
        var _this$props$participa, _this$props$config, _this$props$config$pa, _this$props$participa2, _this$props$config2, _this$props$config2$p;
        var _ref2$value, value, participant_auth_token, enrollment_identifier, query, CancelToken, source, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2$value = _ref2.value, value = _ref2$value === void 0 ? '' : _ref2$value;
                if (_this.cancelSearch) _this.cancelSearch.cancel('new user input');
                _this.setState({
                  loading: true
                });

                // Need to try to retrieve participant_auth_token and enrollment_id from
                // either the direct props or the config props which are passed into the
                // whole form.
                participant_auth_token = ((_this$props$participa = _this.props.participant) === null || _this$props$participa === void 0 ? void 0 : _this$props$participa.participant_auth_token) || ((_this$props$config = _this.props.config) === null || _this$props$config === void 0 ? void 0 : (_this$props$config$pa = _this$props$config.participant) === null || _this$props$config$pa === void 0 ? void 0 : _this$props$config$pa.participant_auth_token);
                enrollment_identifier = ((_this$props$participa2 = _this.props.participant) === null || _this$props$participa2 === void 0 ? void 0 : _this$props$participa2.enrollment_identifier) || ((_this$props$config2 = _this.props.config) === null || _this$props$config2 === void 0 ? void 0 : (_this$props$config2$p = _this$props$config2.participant) === null || _this$props$config2$p === void 0 ? void 0 : _this$props$config2$p.enrollment_identifier);
                query = value.trim().toLowerCase();
                if (!(query.length === 0)) {
                  _context.next = 8;
                  break;
                }
                return _context.abrupt("return", _this.setState({
                  loading: false,
                  suggestions: []
                }));
              case 8:
                if (!(_this.state.lastSearch === query && !_lodash["default"].isEmpty(_this.state.cachedResponse))) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return", _this.setState({
                  suggestions: _this.state.cachedResponse,
                  loading: false
                }));
              case 10:
                _context.prev = 10;
                CancelToken = _axios["default"].CancelToken;
                source = CancelToken.source();
                _this.cancelSearch = source;
                _context.next = 16;
                return (0, _services.searchAddress)({
                  query: query,
                  participant_auth_token: participant_auth_token,
                  enrollment_identifier: enrollment_identifier,
                  take: 5,
                  cancelToken: source.token
                });
              case 16:
                response = _context.sent;
                _this.setState({
                  lastSearch: query,
                  cachedResponse: response.data.results,
                  suggestions: response.data.results,
                  error: false,
                  loading: false
                });
                _context.next = 23;
                break;
              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](10);
                if (!_axios["default"].isCancel(_context.t0)) {
                  (0, _logger.logError)(_context.t0, {
                    component: 'Address'
                  });
                  console.error(_context.t0);
                  _this.setState({
                    error: true,
                    loading: false
                  });
                }
              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[10, 20]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSuggestionSelected", function (e, _ref4) {
      var suggestionValue = _ref4.suggestionValue,
        format = _ref4.suggestion.format;
      _this.props.input.onBlur();
      if (e.keyCode === 13) e.preventDefault(); // prevents enter submitting form when selecting from dropdown
      _this.props.input.onChange({
        value: suggestionValue,
        experian_address_url: format,
        verified: true
      });
      _this.setState({
        loading: false,
        suggestionSelected: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSuggestionsClearRequested", function () {
      _this.setState({
        suggestions: []
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "inputProps", function () {
      var _this$state$value$val, _this$state$value;
      return {
        name: _this.props.input.name,
        placeholder: _this.props.placeholder,
        // Have to set value to '' if undefined or null the autosuggest library we use
        // doesn't handle undefined well in it's boolean statements
        value: (_this$state$value$val = (_this$state$value = _this.state.value) === null || _this$state$value === void 0 ? void 0 : _this$state$value.value) !== null && _this$state$value$val !== void 0 ? _this$state$value$val : '',
        onChange: _this.onChange,
        onKeyPress: _this.onKeyPress,
        onBlur: function onBlur() {
          return _this.props.input.onBlur();
        },
        onFocus: function onFocus(e) {
          return _this.props.input.onFocus(e);
        },
        disabled: _this.props.disabled
      };
    });
    _this.state = {
      value: props.input.value || defaultValue,
      verified: false,
      error: false,
      suggestions: [],
      suggestionSelected: false,
      count: 0,
      loading: false
    };
    _this.debouncedOnSuggestionsFetchRequested = _lodash["default"].debounce(_this.onSuggestionsFetchRequested, 300, {
      leading: false,
      trailing: true,
      maxWait: 1000
    });
    return _this;
  }
  (0, _createClass2["default"])(Address, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        _this$props$meta = _this$props.meta,
        error = _this$props$meta.error,
        touched = _this$props$meta.touched,
        name = _this$props.input.name,
        inputStyle = _this$props.inputStyle,
        label = _this$props.label,
        smallLabel = _this$props.smallLabel,
        labelStyle = _this$props.labelStyle,
        required = _this$props.required,
        t = _this$props.t;
      var commonError = t('common.errorMessage');
      var errorState = touched && error || this.state.error;
      var errorMessage = this.state.error ? commonError : error;
      return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        required: required,
        label: label || smallLabel,
        labelStyle: labelStyle || inputStyle,
        id: name
      }, /*#__PURE__*/_react["default"].createElement(_components.AutosuggestWrapper, null, /*#__PURE__*/_react["default"].createElement(_reactAutosuggest["default"], {
        highlightFirstSuggestion: true,
        suggestions: this.state.suggestions,
        onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props) {
          _this2.debouncedOnSuggestionsFetchRequested.cancel();
          _this2.debouncedOnSuggestionsFetchRequested(props);
        },
        alwaysRenderSuggestions: true,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        onSuggestionSelected: this.onSuggestionSelected,
        getSuggestionValue: function getSuggestionValue(result) {
          return result.suggestion;
        },
        renderSuggestion: function renderSuggestion(result) {
          return /*#__PURE__*/_react["default"].createElement("div", null, result.suggestion);
        },
        inputProps: this.inputProps()
      }), this.state.loading && /*#__PURE__*/_react["default"].createElement(_components.Loader, null)), errorState && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, errorMessage));
    }
  }]);
  return Address;
}(_react["default"].Component);
Address.defaultProps = {
  disabled: false,
  input: {
    value: ''
  },
  meta: {},
  participant: {}
};
Address.propTypes = {
  participant: _propTypes["default"].shape({
    enrollment_identifier: _propTypes["default"].string,
    participant_auth_token: _propTypes["default"].string
  }),
  disabled: _propTypes["default"].bool,
  input: _propTypes["default"].object,
  placeholder: _propTypes["default"].string,
  label: _propTypes["default"].string,
  description: _propTypes["default"].string
};
var AddressWithTranslation = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(Address);
AddressWithTranslation.handlesErrorDisplay = true;
var _default = exports["default"] = AddressWithTranslation;